import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  effect,
  input,
  output,
  untracked,
  viewChild
} from '@angular/core';

export interface UiSelectOption {
  value: string | number;
  label: string;
}

@Component({
  selector: 'app-ui-select',

  template: `
    <select
      #selectEl
      [attr.id]="selectId()"
      [name]="name()"
      [class]="cssClass()"
      [value]="selectedValue() ?? ''"
      (change)="selectionChange.emit($event)">
      @if (showPlaceholder() && placeholder()) {
        <option [disabled]="placeholderDisabled()">{{ placeholder() }}</option>
      }
      @for (opt of options(); track opt.value) {
        <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  `,

  styleUrl: './ui-select.component.scss',

  changeDetection:
    ChangeDetectionStrategy.OnPush
})
export class UiSelectAtomComponent {
  readonly selectId =
    input('');

  readonly name =
    input('');

  readonly cssClass =
    input('input');

  readonly options =
    input<UiSelectOption[]>([]);

  // Valor controlado externamente; si no coincide con ninguna option, el navegador muestra la primera (el placeholder).
  readonly selectedValue =
    input<string | number | null>(null);

  readonly placeholder =
    input('');

  readonly showPlaceholder =
    input(true);

  readonly placeholderDisabled =
    input(false);

  // Al cambiar (boton 'Limpiar filtros') el select vuelve a 'selectedValue' (placeholder si es null),
  // aunque la vista se reutilice. Los selects de categoria no lo usan y conservan su seleccion.
  readonly resetKey =
    input(0);

  readonly selectionChange =
    output<Event>();

  private readonly selectRef =
    viewChild.required<ElementRef<HTMLSelectElement>>('selectEl');

  // La seleccion del usuario vive en el DOM: si el valor ligado a [value] no cambia, Angular no
  // reescribe el elemento, por eso el reinicio se hace de forma imperativa.
  private readonly resetOnKeyChange = effect(() => {
    this.resetKey();
    untracked(() => {
      this.selectRef().nativeElement.value = String(this.selectedValue() ?? '');
    });
  });
}
